<template>
    <div>
        <!-- User Interface controls -->
        <b-row>
            <b-col md="7" class="my-1">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Main table element -->
        <b-table show-empty empty-text="There are no additional forms." striped responsive stacked="md" caption-top
                 :items="items"
                 :fields="fields" 
                 :current-page="currentPage" 
                 :per-page="perPage"
                 :filter="filter" 
                 @filtered="onFiltered"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 >
                 <template v-slot:cell(title)="row">
                     {{ row.item.title }}
                 </template>
                 <template v-slot:cell(evaluator)="row">
                     <div v-if="row.item.self_evaluated == true">
                         Self Evaluated
                     </div>
                     <div v-if="row.item.self_evaluated == false && row.item.role != null">
                         {{ row.item.role.type }}
                     </div>
                 </template>
                <template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                    <b-button @click.stop="row.toggleDetails" class="btn btn-success mb-2">
                        <span class="icon icon-eye">
                            {{ row.detailsShowing ? 'Hide' : 'View'}}</span>
                    </b-button>
                    <b-button v-if="user.role == 'student' || user.role == 'preceptor' || user.role == 'instructor'" @click.stop="sendEval(row.item.id)" class="btn btn-primary mb-2">
                         <span class="icon icon-paper-plane"> Create</span>
                    </b-button>
                    <b-button v-if="user.role == 'admin' || user.role == 'school'" @click.stop="editComp(row.item.id)" class="btn btn-warning mb-2">
                         <span class="icon icon-pencil"></span>
                    </b-button>
                    <b-button v-if="user.role == 'admin' || user.role == 'school'" @click.stop="deleteComp(row.item.id)" class="btn btn-danger mb-2">
                         <span class="icon icon-trash"></span>
                    </b-button>
            </template>
            <template v-slot:row-details="row">
                <b-card>
                    <div class="font-weight-bold mb-3">{{ row.item.title }}</div>
                    <div v-if="row.item.sender_comment == true">
                        <p class="font-weight-bold">Comment (sender)</p>
                    </div>
                    <div v-if="row.item.description">
                        <div v-html="row.item.description"></div>
                    </div>
                    <table class="table table-striped bg-white table-sm mt-3">
                        <tbody v-for="(step, index) in row.item.steps" :key="index">
                            <tr v-if="step['category']" class="bg-primary text-white">
                                <td>
                                    {{ step['category'] }} 
                                </td>
                                <td v-for="(score, index) in row.item.scale.score_description" :key="index">
                                    
                                </td>
                            </tr>
                            <tr>
                                <td v-html="step['step']"></td>
                                <td v-if="step['input'] && step['input'] == true" :colspan="Object.keys(row.item.scale.score_description).map(function(key) {
                                return [Number(key), row.item.scale.score_description[key]];
                                }).length">
                                    <input type="text" disabled>
                                </td>
                                <td v-else v-for="(score, index) in row.item.scale.score_description" :key="index">
                                    {{ index }}
                                </td>
                            </tr>
                        </tbody>
                        <tr v-if="row.item.calc_score == true">
                            <td>
                                <span class="font-weight-bold">Total Score:</span>
                                <div>
                                    <small>Minimum score required: {{ row.item.minimum_score }}%</small>
                                </div>
                            </td>
                            <td v-for="(score, index) in row.item.scale.score_description" :key="index">
                                    
                            </td>
                        </tr>
                    </table>
                    <div v-if="row.item.evaluator_comment == true">
                        <p class="font-weight-bold">Evaluator Comment</p>
                    </div>
                    <div v-if="row.item.anonymous == true">
                        <p class="font-weight-bold text-danger">This evaluation is anonymous, the person will not see who evaluated it.</p>
                    </div>
                </b-card>
            </template>
</b-table>
<b-row>
    <b-col md="12" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
    </b-col>
</b-row>

</div>
</template>

<script>
    const items = [];
    export default {
        props: ['additional_forms'],
        data() {
            return {
                items: this.additional_forms,
                url: this.surl,
                user: window.User,
                fields: [
                    {
                        key: "title",
                        label: "Form",
                        class: "text-uppercase"
                    },
                    {
                        key: "evaluator",
                        label: "Evaluator",
                        class: "text-uppercase"
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "text-nowrap text-uppercase"
                    }
                ],
                currentPage: 1,
                perPage: 25,
                totalRows: this.additional_forms.length,
                pageOptions: [15, 25, 35, 50],
                filter: null,
                sortBy: "title",
                sortDesc: false,
                show: true,
            };
        },
        computed: {
            sortOptions() {
                // Create an options list from our fields
                return this.fields.filter(f => f.sortable).map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
            }
        },
        methods: {
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            required(id) {
                window.location.href = this.surl + id;
            },
            editComp(id) {
                window.location.href = "/additional-form/" + id + "/edit";
            },
            sendEval(id) {
                window.location.href = "/additional-form-evaluation/" + id + "/start";
            },
            deleteComp(id){
                Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                    if (result.isConfirmed) {
                      axios.delete('/additional-form/' + id)
                      .then(response => this.items = response.data)
                      .catch(function (error) {
                          // handle error
                          Swal.fire({
                          title: 'Oops',
                          text: "Something went wrong, please contact support.",
                          icon: 'warning'
                          })
                          console.log(error);
                      });
                    }});
            }
        },
    };
</script>

<!-- table-complete-1.vue -->